import React from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { firstSelected } from '@/utils/resultsHelper';
import { translatedError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import fields from '@/constants/fields';
import CloseButton from '@/components/buttons/CloseButton';
import SaveButton from '@/components/buttons/SaveButton';
import {
  addDatasetCondition,
  hideDatasetCondition,
  updateActiveDatasetConditionConfiguration,
  updateActiveDatasetConditionProperties,
  updateDatasetCondition,
} from '../actions';
import { datasetConditionComponents } from './DatasetConditionForm';
import { availableDatasetConditions } from '../state/state';
import DatasetConditionAdvisoryToggle from '../components/DatasetConditionAdvisoryToggle';
import { isWorkspaceCondition, isAdvisory } from '../helper';

const DatasetConditionDialogActions = ({
  advisory,
  addCondition,
  hasConditions,
  datasetCondition,
  hide,
  isDirty,
  isNew,
  saveStatus,
  updateCondition,
  updateConfiguration,
  updateProperties,
}) => {
  const { condition } = datasetCondition;

  const checkForErrors = () => {
    const validationErrors = [];
    const validator = datasetConditionComponents[condition.code]?.validator;

    if (!condition.code) {
      validationErrors.push(translatedError(
        'dataset.condition',
        'dataset.condition.dropdown.validation.title',
        'dataset.condition.dropdown.validation',
        [fields.CODE],
      ));
    }

    if (validator) {
      validator(datasetCondition, validationErrors, isNew);
    }

    updateProperties({ saveErrors: validationErrors });
    return validationErrors;
  };

  const submitForm = () => {
    const validationErrors = checkForErrors();

    if (validationErrors.length === 0) {
      if (isNew) {
        addCondition();
      } else {
        updateCondition();
      }
    }
  };

  return (
    <Modal.Actions>
      {hasConditions && isWorkspaceCondition(condition) && (
        <DatasetConditionAdvisoryToggle
          advisory={advisory}
          disabled={!condition.code || saveStatus === states.PENDING}
          onClick={(newValue) => updateConfiguration(
            { existing_workspace_condition: newValue ? 'off' : 'on' },
          )}
        />
      )}
      <div>
        <CloseButton
          disabled={saveStatus === states.PENDING}
          messageId={hasConditions ? 'actions.cancel' : 'actions.close'}
          onClick={hide}
        />
        {hasConditions && (
          <SaveButton
            inProgress={saveStatus === states.PENDING}
            messageId={isNew ? 'actions.add' : 'actions.save'}
            minimumDataEntryMet={isDirty}
            onClick={submitForm}
          />
        )}
      </div>
    </Modal.Actions>
  );
};

const mapStateToProps = ({
  datasetConditions: {
    activeCondition,
    conditions,
    datasetConditions,
  },
}) => {
  const filtered = availableDatasetConditions(datasetConditions, conditions, activeCondition);
  const selectedCondition = firstSelected(activeCondition.items) || { condition: { code: null } };

  return {
    advisory: isAdvisory(selectedCondition),
    hasConditions: conditions.readStatus === states.SUCCESS && filtered.conditions.length > 0,
    isDirty: activeCondition.isDirty,
    isNew: activeCondition.isNew,
    saveStatus: activeCondition.saveStatus,
    datasetCondition: selectedCondition,
  };
};

const mapDispatchToProps = {
  addCondition: addDatasetCondition,
  hide: hideDatasetCondition,
  updateCondition: updateDatasetCondition,
  updateProperties: updateActiveDatasetConditionProperties,
  updateConfiguration: updateActiveDatasetConditionConfiguration,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetConditionDialogActions);
